// // src/Components/Loginpage/Login.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './Login.css';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const role = localStorage.getItem('role');
//     if (role) navigate('/'); // Already logged in
//   }, []);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const res = await fetch("/api/login", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await res.json();
// if (res.ok) {
//   alert("✅ Login successful");

//   // Set user data
//   localStorage.setItem("role", data.role);         // e.g., "admin" or "user"
//   localStorage.setItem("userId", data.userId);     // Optional: User ID
//   localStorage.setItem("token", data.token);       // Optional: JWT token

//   // 🔥 Force update in Header component
//   window.dispatchEvent(new Event('storage'));

//   // Navigate to home
//   navigate('/');
// }
//  else {
//         alert(`❌ ${data.message}`);
//       }
//     } catch (err) {
//       console.error("Login error:", err);
//       alert("❌ Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="login-wrapper">
//       <div className="bg-blur-circle top-left"></div>
//       <div className="bg-blur-circle bottom-right"></div>

//       <div className="login-card">
//         <h2 className="login-title">🔐 Login to Your Account</h2>
//         <form onSubmit={handleLogin} className="login-form">
//           <div className="form-group">
//             <label>Email</label>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="Enter your email"
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label>Password</label>
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Enter your password"
//               required
//             />
//           </div>

//           <button type="submit" className="login-button" disabled={loading}>
//             {loading ? "Logging in..." : "🚀 Login"}
//           </button>
//         </form>

//         <p className="signup-text">
//           Don’t have an account? <a href="#">Sign up here</a>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role) navigate('/');
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok) {
        alert("✅ Login successful");
        localStorage.setItem("role", data.role);
        localStorage.setItem("userId", data.userId);
        localStorage.setItem("token", data.token);
        window.dispatchEvent(new Event('storage'));
        navigate('/');
      } else {
        alert(`❌ ${data.message}`);
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("❌ Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="bg-blur-circle top-left"></div>
      <div className="bg-blur-circle bottom-right"></div>

      <div className="login-card">
        <h2 className="login-title">🔐 Login to Your Account</h2>
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group password-group">
            <label>Password</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
              <span
                className="toggle-icon"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "🙈" : "👁️"}
              </span>
            </div>
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Logging in..." : "🚀 Login"}
          </button>
        </form>

        <p className="signup-text">
          Don’t have an account? <a href="#">Sign up here</a>
        </p>
      </div>
    </div>
  );
};

export default Login;
